var _path, _path2, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParameters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M7.2 27.7V14.4c0-3 2.5-5.4 5.7-5.4h16.8c3.1 0 5.7 2.4 5.7 5.4v13.9c0 2.9-2.4 5.2-5.5 5.2H11.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M13 17.2h16.5M13 25.8h16.5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 24.1,
    cy: 17,
    r: 2.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 18,
    cy: 25.8,
    r: 2.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParameters);
export default __webpack_public_path__ + "static/media/parameters.46dfa7c44fe2e34b1dab722ff7c324a4.svg";
export { ForwardRef as ReactComponent };